import(/* webpackMode: "eager" */ "/codebuild/output/src1614243332/src/apps/webapp/src/app/global-error.tsx");
